import {
	Component,
	Input,
	OnChanges,
	OnDestroy,
	SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { SubSink } from 'subsink';

// --- Facades ---
import { CartFacade } from '@facades/cart.facade';
import { ParametersFacade } from '@facades/parameters.facade';
import { ProductsFacade } from '@facades/products.facade';

// --- Interfaces ---
import type { IProduct } from '@interfaces/product';

// --- Utils ---
import { resolveSaleMultiplier } from '@utils/sale-multiplier.util';

@Component({
	selector: 'app-autocomplete-overlay-panel',
	templateUrl: './autocomplete-overlay-panel.component.html',
	styleUrls: ['./autocomplete-overlay-panel.component.scss'],
})
export class AutocompleteOverlayPanelComponent implements OnDestroy, OnChanges {
	private subs = new SubSink();

	@Input() search: string = '';

	isLoading: boolean = false;
	objectFit = this.parameters?.allowResizeProductImages ? 'contain' : 'cover';
	products: IProduct[] = [];

	constructor(
		private _router: Router,
		private parametersFacade: ParametersFacade,
		private productsFacade: ProductsFacade,
		public cartFacade: CartFacade
	) {}

	ngOnChanges(changes: SimpleChanges) {
		this.fetchProductsBySearch(changes);
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}

	private fetchProductsBySearch(changes: SimpleChanges) {
		this.isLoading = true;

		this.subs.add(
			this.productsFacade
				.getProductsSearch({
					search: changes['search'].currentValue,
					pageLimit: 10,
				})
				.pipe(map(res => res.result))
				.subscribe(products => {
					this.products = products;
					this.isLoading = false;
				})
		);
	}

	private get parameters() {
		return this.parametersFacade.parameters;
	}

	searchProduct(search: string) {
		if (search) this._router.navigate(['/'], { queryParams: { search } });
	}

	addToCart(product: IProduct) {
		const hasVariations = Boolean(product.variations?.length);
		if (!this.parameters.allowSellingParentProduct && hasVariations) {
			this._router.navigate(['/product', product.id]);
			return;
		}

		this.cartFacade.addToCart([
			{ product, quantity: resolveSaleMultiplier(product.saleMultiplier) },
		]);
	}
}
